export enum PartnerBitFlag {
  TopBPSWW = 2,
  TopBPSMarket = 8,
  TopOPHWW = 1,
  TopOPHMarket = 4,
}
